import { IComponentOptions, IController } from 'angular';
import { StateService, Transition } from '@uirouter/angularjs';
import { AuthService } from '../../../../core/services/auth/auth.service';
import { ToastrService } from '../../../../core/services/toastr/toastr.service';
import { AppService } from '../../../../app.service';
import './account-activation.component.scss';

export class AccountActivationController implements IController {
  static $inject = [
    '$state',
    'AuthService',
    'AppService',
    'ToastrService'
  ];
  $transition$: Transition;
  loading: boolean;

  constructor( private $state: StateService,
               private authService: AuthService,
               private appService: AppService,
               private toastrService: ToastrService ) {
  }

  $onInit() {
    const code = this.$transition$.params().code;
    if ( !code ) {
      return this.$state.go('app.dashboard.profile');
    }
    this.loading = true;
    this.authService.activateAccount(code)
      .then(async (data) => {
        console.log(data);
        this.toastrService.info('Account activated');
        if (this.authService.isEmployer()) {
          await this.$state.go('app.dashboard.profile');
        } else {
          await this.$state.go('app.dashboard.cv.personal-info');
        }
        await this.authService.verifyToken().then((res) => {
          this.authService.authUser({ token: res.token }, false);
        });
      })
      .catch(( err ) => {
        if ( err.data ) {
          this.toastrService.error(err.data.text || 'Error');
        } else {
          this.toastrService.error(err.message || 'Error');
        }
        this.$state.go('app.public.auth.login');
      });
  }
}

export const AccountActivationComponent: IComponentOptions = {
  controller: AccountActivationController,
  template: require('./account-activation.component.html'),
  bindings: {
    $transition$: '<'
  }
};



// WEBPACK FOOTER //
// ./app/states/auth/components/account-activation/account-activation.component.ts